import { useQuery } from '@tanstack/react-query';
import Coupon from '../models/Coupon';

export default function useHolidayCoupon() {
  return useQuery(['coupon', 'holiday'], () => (
    Coupon
      .where({ forHolidayPackage: true })
      .first()
      .then((res) => res.data)
  ));
}
